import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

export default {
    namespaced: true,
    state: {
        permissionGroups: [],
        roleList: [],
        role: {
            name: '',
            display_name: '',
            permissions: [],
        },
    },
    getters: {
        permissionGroups: state => state.permissionGroups,
        permissions: state => {
            const permissions = [];

            state.permissionGroups.forEach(g => {
                g.permissions.forEach(p => {
                    permissions.push(p);
                });
            });

            return permissions;
        },
        role: state => state.role,
        roleList: state => state.roleList,
        roleHasPermission: state => pid => {
            const permission = state.role.permissions.find(p => p.id == pid);
            return !_.isNil(permission);
        },
    },
    mutations: {
        [types.SET_PERMISSION_GROUPS](state, permissionGroups) {
            state.permissionGroups = permissionGroups;
        },

        [types.SET_ROLE](state, role) {
            state.role = role;
        },

        [types.SET_ROLE_LIST](state, roleList) {
            state.roleList = roleList;
        },

        [types.ADD_ROLE_PERMISSION](state, permission) {
            state.role.permissions.push(permission);
        },

        [types.REMOVE_ROLE_PERMISSION](state, index) {
            state.role.permissions.splice(index, 1);
        },
    },
    actions: {
        async getPermissionGroups({ commit }) {
            try {
                const { data } = await axios.get(
                    Laroute.route('role_permissions.permission_groups'),
                );

                commit(types.SET_PERMISSION_GROUPS, data);
                return data;
            } catch (e) {
                throw e;
            }
        },

        async getRole({ commit }, name) {
            try {
                const { data } = await axios.get(
                    Laroute.route('role_permissions.role', { name }),
                );

                commit(types.SET_ROLE, data);
                return data;
            } catch (e) {
                throw e;
            }
        },

        async getRoleList({ commit, dispatch }, name) {
            startLoading(dispatch, 'fetch-roles');

            try {
                const { data } = await axios.get(
                    Laroute.route('data_api.roles', { name }),
                );

                commit(types.SET_ROLE_LIST, data);
                endLoading(dispatch, 'fetch-roles');

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-roles');
                throw e;
            }
        },

        togglePermission({ commit, getters }, permission_id) {
            const index = getters.role.permissions.findIndex(
                p => p.id == permission_id,
            );

            if (index >= 0) {
                commit(types.REMOVE_ROLE_PERMISSION, index);
            } else {
                const permission = getters.permissions.find(
                    p => p.id == permission_id,
                );
                commit(types.ADD_ROLE_PERMISSION, permission);
            }
        },

        async savePermission({ commit, getters }) {
            const name = getters.role.name;
            const url = Laroute.route('role_permissions.assign_permissions', {
                name,
            });

            const permissions = getters.role.permissions.map(p => p.name);

            try {
                const { data } = await axios.put(url, { permissions });
                commit(types.SET_ROLE, data);
            } catch (e) {
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/role-permission.js